// extracted by mini-css-extract-plugin
export var demoBtn = "Pricing-module--demoBtn--f0643";
export var demoBtnPOP = "Pricing-module--demoBtnPOP--7a937";
export var popContainer = "Pricing-module--popContainer--33364";
export var pricingContainer = "Pricing-module--pricingContainer--e2c2a";
export var pricingTiers = "Pricing-module--pricingTiers--d0281";
export var pricingTitle = "Pricing-module--pricingTitle--16299";